export enum LoadingState {
    /**
     * Indicating that the requested identifier never loaded or started loading
     */
    INITIAL = 'initial',
    LOADING = 'loading',
    LOADED = 'loaded'
}
